ction. Here is the proposed change.
Code
CopyInsert
<template>
  <div class="login-page">
    <!-- 右上角logo -->
    <img src="/image/login-logo.png" alt="login logo" class="login-logo">
    
    <!-- 左侧区域 -->
    <div class="login-left">
      
      <img src="/image/login-1.png" alt="login illustration 1" class="login-image login-image-1">
      <div class="welcome-text">
        <h1>Hello!</h1>
          <p>欢迎来到中泽科教激光切割教育云平台</p>
          <p class="sub-title">Welcome to Nakazawa Laser Cutting Education cloud platform</p>
        </div>
      <div class="login-image-container">
        <img src="/image/login-2.png" alt="login illustration 2" class="login-image login-image-2">
        
      </div>
    </div>

    <!-- 右侧登录框 -->
    <div class="login-right">
      <div class="login-form">
        <h2>学生端登陆</h2>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <!-- 账号输入框 -->
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="账号"></el-input>
          </el-form-item>

          <!-- 密码输入框 -->
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
          </el-form-item>

          <!-- 验证码输入框 -->
          <el-form-item prop="captcha">
            <div class="captcha-container">
              <el-input v-model="loginForm.captcha" placeholder="验证码" />
              <div class="captcha-box">
                <span class="captcha-text" @select="preventCopy">{{ generatedCaptcha }}</span>
                <img src="/image/update.png" @click="refreshCaptcha" :class="{'rotating': isCaptchaRefreshing}" alt="refresh" class="update-icon">
              </div>
            </div>
          </el-form-item>

          <!-- 登录按钮 -->
          <el-form-item>
            <el-button type="primary" class="login-button" @click="onSubmit">登陆</el-button>
          </el-form-item>

          <!-- 注册和忘记密码 -->
          <div class="login-footer">
            <span>还没有账户吗? <el-link type="primary" @click="onRegister">去注册</el-link></span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      generatedCaptcha: '', // 存储生成的验证码
      isCaptchaRefreshing: false, // 防止重复刷新
      refreshCooldown: 10, // 验证码刷新间隔时间（秒）
      countdown: 10, // 倒计时
      timer: null // 用于保存倒计时
    };
  },
  mounted () {
    this.getCaptcha(); // 初始化获取验证码
  },
  methods: {
    async getCaptcha () {
      try {
        const { data } = await axios.get('/api/captcha/generate'); // 获取验证码
        this.generatedCaptcha = data.data; // 存储验证码内容
      } catch (error) {
        this.$message.error('验证码获取失败，请稍后重试');
      }
    },
    refreshCaptcha () {
      if (this.isCaptchaRefreshing) return; // 如果正在冷却中则不允许刷新
      this.getCaptcha(); // 获取新验证码

      // 开始10秒冷却倒计时
      this.isCaptchaRefreshing = true;
      this.countdown = this.refreshCooldown;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(this.timer);
          this.isCaptchaRefreshing = false;
        }
      }, 1000);
    },
    preventCopy (event) {
      event.preventDefault(); // 阻止文本选择
    },
    async onSubmit () {

      // this.$router.push('/dashboard');
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          // 验证码检查
          if (this.loginForm.captcha !== this.generatedCaptcha) {
            this.$message.error('验证码错误，请重新输入');
            return;
          }

          try {
            const response = await axios.post('/api/auth/login', {
              accountNumber: this.loginForm.username,
              password: this.loginForm.password,
            });

            if (response.data.success) {
              // const authToken = response.data.token;
              const userInfo = response.data.data;
              localStorage.setItem('cloud', '1111');
              localStorage.setItem('userInfo', JSON.stringify(userInfo.accountNumber));

              // 同时保留原始用户信息以备后用
              this.originalUserInfo = userInfo; 

              this.$message.success('登录成功');
              this.$router.push('/dashboard');
            } else {
              this.$message.error(response.data.message || '登录失败，请检查账号或密码');
            }

          } catch (error) {
            console.error('请求错误:', error);
            this.$message.error('请求失败，请稍后重试');
          }
        }
      });
    },
    onRegister () {
      this.$router.push('/register');
    },
    onForgotPassword () {
      this.$router.push('/forgot');
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer); // 清除倒计时
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  height: 100vh;
  background: #fff;
  position: relative;
  overflow: hidden;
}

.login-logo {
  position: absolute;
  top: 50px;
  right: 100px;
  height: 52px;
  z-index: 10;
}

.login-left {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-image {
  position: absolute;
  max-width: 100%;
}

.login-image-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-image-1 {
  z-index: 2;
  top: 39%;
  width: 700px;
  left: 8%;
}

.login-image-2 {
  z-index: 1;
  top: 0px;
  left: 0;
  bottom: 20%;
  width: 850px;
}

.welcome-text {
  position: absolute;
  bottom: 70%;
  left: 60%;
  transform: translateX(-50%);
  text-align: left;
  color: #fff;
  width: 100%;
  z-index: 3;
}
.welcome-text h1 {
  margin: 0;
  font-size: 70px;
}
.welcome-text p {
  margin: 8px 0;
  font-size: 18px;
  
}

.welcome-text .sub-title {
  font-size: 18px;
  opacity: 1;
}

.login-right {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 100px;
  margin-top: -50px;

}

.login-form {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.login-form h2 {
  margin-bottom: 24px;
  color: #333;
  font-size: 24px;
  font-weight: 500;
}

.el-input {
  border-radius: 8px;
}

.captcha-container {
  display: flex;
  gap: 12px;
}

.captcha-box {
  display: flex;
  align-items: center;
  gap: 8px;
}

.captcha-text {
  font-size: 20px;
  padding: 4px 12px;
  background: #5AB8FF;
  border-radius: 4px;
  color: #fff;
  user-select: none;
  min-width: 80px;
  text-align: center;
}

.update-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.login-button {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background: #409EFF;
  margin-top: 16px;
}

.login-footer {
  text-align: center;
  margin-top: 24px;
  color: #666;
}

.rotating {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>